module.exports = __webpack_public_path__ + "static/media/glossary.a9fd6a74.svg";